import { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useParallax, useParallaxController, Parallax } from 'react-scroll-parallax';
import IphoneMockup1 from '../../assets/Mockups/iPhone 13 Pro Max_iphone13promaxgold_portrait.png';
import IphoneMockup2 from '../../assets/Mockups/iPhone 13 Pro Max-1_iphone13promaxgold_portrait.png';
import IphoneMockup3 from '../../assets/Mockups/iPhone 13 Pro Max-devices_iphone13promaxgold_portrait.png';
import DashMock1 from '../../assets/Mockups/Houses-1.png';
import DashMock2 from '../../assets/Mockups/Houses.png';
// import DashImg from '../../assets/images/dashboard/dash_houses.png';
import GlobalStyle from '../../helpers/Fonts';

const ParallaxSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const InnerParallaxSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    /* align-items: center; */
    /* background-color: #F5F5F5; */
    /* height: 179vh; */
    /* padding: 100px 0 0px 0; */
    /* padding: 0; */
    width: 100%;
    max-width: 1303px;
    padding: 0 20px;
`;

////////////////////////////////////////////
////       Left Parallax Section       /////
////////////////////////////////////////////
const InnerParallaxSectionContainer = styled.div`
  /* 
    Note: The ImageSection needs to have a larger height value than
    InnerParallaxSectionLeft
   */
  display: flex;
  margin-bottom: ${props => props.marginBottom};
  /* align-items: center; */
  height: ${props => props.height};
  /* padding: 0px; */
  width: 100%;
  top: 0; 
  /* transition: top 0.3s ease-in-out; */
  @media(max-height: 1120px) {
    /* padding: 90px 0; */
  }

  @media only screen and (max-width: 1328px) {
    display: flex;
    flex-direction: column;
    height: 1000px;
    margin: 0;
    text-align: center;
    margin-bottom: 100px;
    /* padding: 20px; */
    /* width: 100%; */
  }
  @media only screen and (max-width: 614px) {
    margin-bottom: 0;
  }
`

const TextSection = styled.div`
  /* display: flex;
  flex-direction: column;
  justify-content: space-between; */
  width: 100%;
  overflow-wrap: break-word;
  padding-right: 120px;
  /* border-bottom: 1px solid black; */
  /* background-color: blue; */
  @media only screen and (max-width: 1328px) {
    padding: 0;
  }
`;

const Text = styled.p`
  font-size:  ${props => props.size || '16px'};
  font-weight: ${props => props.weight || '400'};
  color: ${props => props.color || '#fff'};
  font-family: ${props => props.font || 'Poppins'};
  margin-top: ${props => props.marginTop || '0px'};
  margin-bottom: ${props => props.marginBottom || '0px'};
  letter-spacing: ${props => props.letterSpacing || '0px'};

  @media only screen and (max-width: 1328px) {
    padding: 0;
    margin-top: 0;
  }

  @media only screen and (max-width: 614px) {
    margin-bottom: 30px;
  }
`
////////////////////////////////////////////
////       Left Parallax Section       /////
////////////////////////////////////////////


////////////////////////////////////////////
////      Right Parallax Section       /////
////////////////////////////////////////////

const ImageSection = styled.div`
  width: 100%;
  position: relative;
  /* > div{
    scroll-snap-align: start;
  } */

  height: 100%;

  @media(max-height: 1120px) {
    /* height: 100vh; */
  }
`

const SmImage = styled.img`
  
`

const Image = styled.img`
  width: ${props => props.width};
  left: ${props => props.left};
  right: ${props => props.right};
  top: ${props => props.top};
  bottom: ${props => props.bottom};
  z-index: ${props => props.zIndex || '0'};
  position: absolute;
  margin: 0;
  padding: 0;

  @media only screen and (max-width: 1328px) {
    z-index: 0;
    position: absolute;
    /* width: 100%; */
  }

  @media only screen and (max-width: 614px) {
    z-index: 0;
    position: absolute;
    width: 70%;
  }
`

const DashImg = styled.img`
  width: ${props => props.width};
  left: ${props => props.left};
  right: ${props => props.right};
  top: ${props => props.top};
  bottom: ${props => props.bottom};
  z-index: ${props => props.zIndex || '0'};
  position: static;
  margin: 0;
  padding: 0;

  @media only screen and (max-width: 1328px) {
    z-index: 0;
    position: absolute;
    /* width: 100%; */
  }

  @media only screen and (max-width: 614px) {
    z-index: 0;
    position: static;
    width: 100%;
  }
`

////////////////////////////////////////////
////      Right Parallax Section       /////
////////////////////////////////////////////

function ParallaxSections() {
  // const { ref: ImgRef1 } = useParallax({ speed: 40 });
  // const { ref: ImgRef2 } = useParallax({ speed: 10 });
  // const { ref: ImgRef3 } = useParallax({ speed: 50 });
  // const { ref: ImgRef4 } = useParallax({ speed: 30 });
  // const { ref: ImgRef5 } = useParallax({ speed: 50 });
  // const { red: ScrollPosition } = useRef(0);
  
  const parallaxController = useParallaxController();

  const [replay, setReplay] = useState(true);

  return (
    <ParallaxSection>
      <GlobalStyle />
        <InnerParallaxSection>
          <InnerParallaxSectionContainer 
            height="500px"
            marginBottom={"300px"}
           >
            <TextSection className="text-section">
              <Text
                marginTop="150px"
                size="48px"
                weight="700"
                color="#fff"
                marginBottom="30px"
                font="Poppins Bold"
                className="heading1"
              >
                Mobile App
              </Text>
              <Text
                size="20px"
                font="Poppins SemiBold"
                marginBottom="10px"
                letterSpacing="-0.5px"
              >
                Telem mobile app<span style={{margin:"0 7px"}} > • </span>Multi space access
              </Text>
              <Text
                size="16px"
                font="Poppins Regular"
                // marginBottom="230px"
              >
                Securely connects with Telem management dashboard to easily manage devices.
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum atque eos sequi dolor expedita quibusdam voluptates, vitae accusamus necessitatibus delectus! Cumque ullam, tenetur rerum porro corrupti placeat adipisci soluta neque voluptate maiores ab, fuga molestias dolores aperiam praesentium, temporibus iusto!
              </Text>
            </TextSection>
            <ImageSection>
              <Image 
                width={"336px"} 
                top={"0px"}
                right={"0px"}
                zIndex={"1"}
                src={IphoneMockup1} 
                alt="" 
              />
              <Image 
                width={"336px"} 
                left={"0px"}
                top={"0"}
                zIndex={"10"}
                src={IphoneMockup3} 
                alt=""
              />
            </ImageSection>
          </InnerParallaxSectionContainer>
          <InnerParallaxSectionContainer
            height="500px"
            marginBottom={"300px"} 
          >
             <TextSection>
              <Text
                size="48px"
                weight="700"
                color="#fff"
                marginTop="100px"
                marginBottom="30px"
                font="Poppins Bold"
              >
                Dashboard
              </Text>
              <Text
                size="20px"
                font="Poppins SemiBold"
                marginBottom="10px"
                letterSpacing="-0.5px"
              >
                Telem web dashboard<span style={{margin:"0 7px"}} > • </span>Multi space monitoring
              </Text>
              <Text
                size="16px"
                font="Poppins Regular"
                marginBottom="230px"
              >
                Telem management dashboard to easily manage all devices.
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Deleniti ex, iure quaerat rerum dolores, 
                vero iusto ad soluta aspernatur magnam hic? Fugiat consectetur voluptas aperiam architecto delectus
                 quidem id aliquid, expedita, omnis magni sit assumenda unde
                 voluptatem, ratione officiis? Provident.
              </Text>
            </TextSection>
            <ImageSection className="image-section">
              <DashImg 
                width={"550px"}
                left={"0px"}
                bottom={"0px"}
                zIndex={"10"}
                src={DashMock1} 
                alt="" 
              /> 

              <DashImg 
                width={"500px"} 
                top={"0px"}
                right={"0px"}
                zIndex={"1"}
                src={DashMock2} 
                alt="" 
              />
            </ImageSection>
          </InnerParallaxSectionContainer>
        </InnerParallaxSection>
    </ParallaxSection>
  )
}

export default ParallaxSections